import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule  } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared-module';
import { MaterialModule } from 'src/app/material.module';
import { AlertSummaryModule } from 'src/app/shared/components/alert-summary/alert-summury.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MultiTagsModule } from 'src/app/shared/components/controls/regular-edit/autocomplete/multi-tags/multi-tags.module';
import { BottomSheetMenuModule } from 'src/app/shared/components/bottom-sheet-menu/bottom-sheet-menu.module';
import { SortingArrowComponent } from './sorting-arrow.component';


@NgModule({
    imports: [
      CommonModule,
    //   MatTableModule,
    //   MatInputModule,
    //   MatPaginatorModule,
    //   MatSortModule,
    //   MatProgressSpinnerModule,
    //   MatDialogModule,
    //   MatFormFieldModule,
    //   MatIconModule,
    //   MatButtonModule,
    //   MatCheckboxModule,
    //   FormsModule,
    //   ReactiveFormsModule,
    //   MatChipsModule,
    //   MatAutocompleteModule,
    //   MatSelectModule,
    //   MatToolbarModule,
    //   MatBadgeModule,
    //   MatDatepickerModule,
    //   MatSlideToggleModule,
    //   MultiTagsModule,
    //   MaterialModule,
    //   AlertSummaryModule,
    //   BottomSheetMenuModule,
    //   FlexLayoutModule,
    //   SharedModule
    ],
    declarations: [SortingArrowComponent],
    exports: [SortingArrowComponent]
  })
  export class SortingArrowModule { }
